<script lang="ts">
    import { PUBLIC_CLOUDFLARE_BUCKET_URL } from '$env/static/public';
    import Img from '@zerodevx/svelte-img';
    import { buildTransformUrl } from '$lib/util/imageTransformationUtil';

    interface ImageSources {
        sources: Record<'avif' | 'webp', string>;
        img: {
            src: string;
            w: number;
            h?: number;
            lqip?: string;
        };
    }

    export let imageId: string;

    export let widths: number[] | undefined = undefined;

    /**
     * &lt;img&gt; element `sizes` attr
     * @type {string|undefined}
     */
    export let sizes = undefined;

    /**
     * &lt;img&gt; `width` override
     */
    export let width: number | undefined = undefined;

    /**
     * &lt;img&gt; `height` override
     */
    export let height: number | undefined = undefined;

    /**
     * &lt;img&gt; element `loading` attr
     */
    export let loading: 'lazy' | 'eager' = 'lazy';

    /**
     * &lt;img&gt; element `decoding` attr
     */
    export let decoding: 'async' | 'auto' | 'sync' = 'async';

    function buildImageSources(imageId: string, widths: number[], height: number): ImageSources {
        widths.sort((a, b) => b - a);

        const buildUrl = (format: 'jpeg' | 'auto' | 'avif' | 'webp' | 'baseline-jpeg' | 'json', width: number) =>
            buildTransformUrl(PUBLIC_CLOUDFLARE_BUCKET_URL, imageId, {
                quality: 81,
                format,
                width
            }) + ` ${width}w`;

        return {
            sources: {
                avif: widths.map((width) => buildUrl('avif', width)).join(', '),
                webp: widths.map((width) => buildUrl('webp', width)).join(', ')
            },
            img: {
                src: buildUrl('webp', widths[widths.length - 1]),
                w: widths[widths.length - 1],
                h: height,
                lqip: '#00000000'
            }
        };
    }

    $: imageSources = buildImageSources(imageId, Array.isArray(widths) ? widths : [width ?? 200], height);
</script>

<Img src={imageSources} {sizes} {width} {height} {loading} {decoding} {...$$restProps} />
